import { Logo } from '@components/Icons';
import React, { useEffect } from 'react';
import cn from 'classnames';
import styles from './OpenInDesktop.module.scss';
import { useLocation, useParams } from 'react-router-dom';
import { appDesktopProtocol } from '@app/config';
import { LoginButton } from '@components/Login/Buttons';
import { WordSeparator } from '@components/Login/AuthOptions';

export default function OpenInDesktop() {
  const { '*': splat } = useParams();
  const location = useLocation();
  const path = `${splat}${location.search}`;

  const hrefFor = (target: 'web' | 'desktop') => {
    if (target === 'web') {
      return `${window.location.origin}/${path}`;
    } else {
      return `${appDesktopProtocol}://${path}`;
    }
  };

  useEffect(() => {
    window.location.href = hrefFor('desktop');
  }, []);

  return (
    <div className={styles.viewWrapper}>
      <div className={styles.viewWrapperInner}>
        <Logo className={styles.clayLogo} customColor="#fff" />
        <div className={cn(styles.content)}>
          <LoginButton onClick={() => (window.location.href = hrefFor('desktop'))}>
            Open Clay App
          </LoginButton>
          <WordSeparator className={styles.orSeparator} />
          <a href={hrefFor('web')}>Continue in your browser.</a>
        </div>
      </div>
    </div>
  );
}
